import React from "react";
import "./Home.css";

function Home() {
  return (
    <div>
      {/* <Section id="first-img"/> */}
      <div id="first-img">
        <div id="firstImg-text">
          <h1>Where dreams meet reality, and magic is made.</h1>
          <b>Welcome to Shree Event!</b>
        </div>
      </div>
      <div class="text-block text-block-1">
  <h1>
    Shree Event is a dynamic event management firm based in Chittorgarh,
    Rajasthan. With a blend of business acumen and creative flair, we redefine
    event experiences.
    <br />
    <br />
    Our team specializes in executing events that align with strategic goals,
    amplify marketing efforts, and foster lasting connections. From concept to
    completion, we craft unforgettable moments that leave a lasting impact.
    <br />
    <br />
    Let Shree Event turn your vision into reality.
  </h1>
</div>

      <div id="Second-img">
        <div id="SecondImg-text">
          <h1>Life's special moments deserve the Shree touch</h1>
          <b> unforgettable, impeccable, and filled with joy</b>
        </div>
      </div>
      <div className="text2">
        <h1>Shree Event: Your Strategic Event Partner</h1>
        <p>
          
            At Shree Event, precision is our hallmark. Regardless of scale, we
            approach every event with meticulous planning, clear objectives, and
            a commitment to your success.
          
        </p>
        <h2>Your Goals, Our Focus</h2>
        <p>
          
            We prioritize your organization, tailoring events to meet your
            specific needs and challenges. Let us transform your vision into
            reality, ensuring your event is delivered flawlessly, on time, and
            within budget.
          
        </p>
      </div>
      <div id="third">
        <div id="third-img" />
      </div>

      
        <div class="text3">
          <h1>How Shree Event Works</h1>
          <div class="section">
            <h2>DISCOVER: GETTING TO KNOW YOU</h2>
            <p>
              We delve into your business, challenges, and client needs. By
              understanding your organizational culture and long-term goals, we
              become your strategic event management partners.
            </p>
          </div>
          <div class="section">
            <h2>BUILD: WE HANDLE THE HEAVY LIFTING</h2>
            <p>
              Armed with insights, trust us to execute flawlessly. From planning
              to execution, we manage every detail with precision and
              professionalism, drawing from our network of trusted vendors and
              years of experience.
            </p>
          </div>
          <div class="section">
            <h2>DELIVER: SIT BACK AND RELAX</h2>
            <p>
              Experience seamless event management. From logistics to on-site
              coordination, we ensure every aspect is meticulously handled,
              allowing you to focus on your attendees and stakeholders.
            </p>
          </div>
        </div>
        <div class="text4">
          
            <h1>Experience the Shree Event Difference</h1>
            <p>
              From tailored agendas to dynamic speakers, vibrant exhibitions,
              strategic partnerships, and exceptional service, we transform
              events into unforgettable experiences.
            </p>
            <p>Let Shree Event take your events to new heights.</p>
          
        </div>
      </div>
    
  );
}

export default Home;
